<router-outlet ></router-outlet>
<ngx-ui-loader [text]="loaderText"></ngx-ui-loader>